import { Button } from "@cluey/cluey-components";
import { InlineLoader } from "../common";
import { FC } from "react";

const LoginSubmitButton: FC<{ loading: boolean; label: string; disabled?: boolean }> = ({ loading, label, disabled = false }) => (
  <Button size="lg" type="submit" disabled={loading || disabled} className="flex w-full max-w-sm flex-row justify-center">
    {!loading ? label : <InlineLoader />}
  </Button>
);

export default LoginSubmitButton;